"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamNativeBalance = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var common_evm_utils_1 = require("@moralisweb3/common-evm-utils");
/**
 * The NativeBalance class is a representation of a nativeBalance-address pair
 *
 * @category DataType
 */
var StreamNativeBalance = /** @class */ (function () {
    function StreamNativeBalance(data, core) {
        this._data = StreamNativeBalance.parse(data, core);
    }
    StreamNativeBalance.create = function (data, core) {
        if (data instanceof StreamNativeBalance) {
            return data;
        }
        var finalCore = core !== null && core !== void 0 ? core : common_core_1.CoreProvider.getDefault();
        return new StreamNativeBalance(data, finalCore);
    };
    StreamNativeBalance.parse = function (input, core) {
        return {
            address: common_evm_utils_1.EvmAddress.create(input.address, core),
            balance: common_evm_utils_1.EvmNative.create(input.balance, 'wei'),
        };
    };
    StreamNativeBalance.equals = function (valueA, valueB) {
        var nativeBalanceTriggerA = StreamNativeBalance.create(valueA);
        var nativeBalanceTriggerB = StreamNativeBalance.create(valueB);
        return (nativeBalanceTriggerA.address.equals(nativeBalanceTriggerB.address) &&
            nativeBalanceTriggerA.balance.equals(nativeBalanceTriggerB.balance));
    };
    /**
     * Compares an NativeBalance data to this NativeBalance instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * nativeBalanceTrigger.equals(value);
     * ```
     */
    StreamNativeBalance.prototype.equals = function (value) {
        return StreamNativeBalance.equals(this, value);
    };
    /**
     * Converts the NativeBalance instance to a JSON object.
     * @returns JSON object of the NativeBalance instance
     * @example `nativeBalanceTrigger.toJSON()`
     */
    StreamNativeBalance.prototype.toJSON = function () {
        var _a = this._data, address = _a.address, balance = _a.balance;
        return {
            address: address.format(),
            balance: balance.format(),
        };
    };
    /**
     * Converts the NativeBalance instance to a JSON object.
     * @returns JSON object of the NativeBalance instance
     * @example `nativeBalanceTrigger.format()`
     */
    StreamNativeBalance.prototype.format = function () {
        return this.toJSON();
    };
    Object.defineProperty(StreamNativeBalance.prototype, "address", {
        get: function () {
            return this._data.address;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamNativeBalance.prototype, "balance", {
        get: function () {
            return this._data.balance;
        },
        enumerable: false,
        configurable: true
    });
    return StreamNativeBalance;
}());
exports.StreamNativeBalance = StreamNativeBalance;
//# sourceMappingURL=StreamNativeBalance.js.map